import { InMemoryCache } from "@apollo/client";
import possibleTypesResult from "./__generated__/possibleTypes";

export const createCache = () => {
  const cache = new InMemoryCache({
    // possibleTypes を渡さないと InMemoryCache は interface / union を型条件に持つ
    // fragment をマッチさせられず、その選択フィールドを黙って捨てる
    // （Policies#fragmentMatches は usingPossibleTypes が false のとき
    // typename === 型条件 でしか true を返さない）。union は inline fragment の
    // 型条件が具象型名と一致するので影響を受けないが、interface fragment
    // （CustomerOperationLogEntry など）はキャッシュ経由で全フィールドが
    // undefined になる。schema から生成した対応表を渡して防ぐ。
    possibleTypes: possibleTypesResult.possibleTypes,
    typePolicies: {
      Query: {},
    },
  });

  return cache;
};
